import { Order } from '@components/account/types'
import { useRouter } from 'next/router'
import { getOrderImages } from '../../helpers/getOrderImages'
import styles from './styles.module.scss'
import { formatDate } from '@helpers/utils'
import OrderItemImage from '../../shared/OrderItemImage'
import { Button } from '@components/ui/Button'
import { prefixLocale } from '@helpers/env'
import Link from '@components/ui/Link'
import { getReturnLink, canArrangeReturn } from '../../helpers/getReturnLink'

const MAX_ORDER_IMAGES = 3

export function OrderItemContent({
  createdAt,
  fulfillments,
  name,
  id,
  status,
  zipCode,
  lineItems
}: {
  id: string
  name: string
  createdAt: string
  fulfillments: Partial<Order>['fulfillments']
  lineItems: Partial<Order>['lineItems']
  status: string
  zipCode?: string
}) {
  const router = useRouter()
  const orderImages = getOrderImages(fulfillments, lineItems)
  const displayedImages = orderImages.slice(0, MAX_ORDER_IMAGES)
  const totalExtraImages = orderImages.length - MAX_ORDER_IMAGES

  const handleButtonClick = () => {
    router.push(
      {
        href: `${prefixLocale()}/account?page=orders-page`,
        query: { page: 'orders-page', orderId: id }
      },
      `${prefixLocale()}/account?page=orders-page&orderId=${id}`,
      {
        scroll: true,
        shallow: true
      }
    )
  }

  return (
    <div className={styles.OrderItemContent}>
      <p className={styles.OrderItemContent__date}>
        Order placed: {formatDate(createdAt)}
      </p>
      <div className={styles.OrderItemContent__wrapper}>
        <div className={styles.OrderItemContent__imagesWrapper}>
          <button
            className={styles.OrderItemContent__images}
            onClick={handleButtonClick}
            aria-label={`View order ${name}`}
          >
            {displayedImages.map((image, index) => (
              <OrderItemImage key={`order-image-${index}`} image={image} />
            ))}
          </button>
          {totalExtraImages > 0 && (
            <div className={styles.OrderItemContent__moreImages}>
              + <strong>{totalExtraImages}</strong> more item
              {totalExtraImages > 1 ? 's' : ''}
            </div>
          )}
        </div>
        <div className={styles.OrderItemContent__actionArea}>
          <Button
            variant="brand_orange"
            fullWidth="inherit"
            onClick={handleButtonClick}
          >
            View Order
          </Button>
          {status === 'In Transit' && (
            <p>Your order is in transit and can no longer be cancelled.</p>
          )}
          {canArrangeReturn(status) && (
            <Link
              href={getReturnLink(name, zipCode || '')}
              target="_blank"
              classes={styles.OrderItemContent__arrangeReturnButton}
            >
              Arrange a return
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
